import React, { Component } from 'react';
import _ from 'lodash';

import RenterLayout from './renter/RenterLayout';
import RenterDashboardLayout from './renter/RenterDashboardLayout';
import AdminLayout from './admin/AdminLayout';
import SearchLayout from './renter/SearchLayout';



export default class DefaultLayout extends Component {
  static defaultProps = {
    routes: [],
    navigation: { items: [] }
  };

  

  render() {
    let navConfig;
    if (!_.isEmpty(this.props.user) && this.props.user.registration.inProgress && this.props.userType === 'pm') {
      navConfig = _.map(this.props.navigation.items, (conf) => ({ ...conf, attributes: { disabled: true } }));
    } else {
      navConfig = _.map(this.props.navigation.items, (conf) => ({ ...conf, attributes: { disabled: false } }));
    }

    if (this.props.dashboardType === 'admin') {
      return (
        <AdminLayout
          {...this.props}
          navConfig={navConfig}
        />
      );
    }
    else if (this.props.dashboardType === 'renter') {
      return (
        <RenterLayout {...this.props} />
      )
    }
    else if (this.props.dashboardType === 'search') {
      return (
        <SearchLayout {...this.props} />
      )
    }
    else if (this.props.dashboardType === 'renter-dashboard') {
      return (
        <RenterDashboardLayout
          {...this.props}
          navConfig={navConfig}
        />
      )
    }


    // if (this.props.userType !== 'pm' && this.props.userType !== 'client') {
    //   if(this.props.location.pathname === '/search') {
    //     return (
    //       <SearchLayout {...this.props}/>
    //     )
    //   }
    //   if(!_.isNil(_.find(navConfig, (el) => el.url === this.props.location.pathname))) {
    //     return (
    //       <RenterDashboardLayout {...this.props} navConfig={navConfig}/>
    //     )
    //   }
    //   return (
    //     <RenterLayout {...this.props}/>
    //   )
    // }

    // return (
    //   <AdminLayout
    //     {...this.props}
    //     navConfig={navConfig}
    //   />
    // )
  }
}

